import './input.scss';

import {
    faCheckCircle as faSolidCheckCircle,
    faCircleNotch,
    faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { BarcodeReader } from '@skinsoft/ui';
import { BFormInput } from 'bootstrap-vue';
import { Component, Vue, Watch } from 'vue-property-decorator';

export enum ValidationStates {
    ERROR = 'error',
    PENDING = 'pending',
    SUCCESS = 'success',
    VALIDATING = 'validating',
}

@Component({
    components: {
        sBarcodeReader: BarcodeReader,
    },
    props: {
        active: { type: Boolean },
        barcodeSensitive: { type: Boolean },
        defaultValue: { type: String, default: null },
        label: { type: String, default: null },
        validationState: { type: String },
    },
    template: require('./input.html'),
})
export class Input extends Vue {
    public active: boolean; // used to know which input should mount the barcode reader
    public defaultValue: string;
    public validationState: ValidationStates;

    public $refs: {
        input: BFormInput
    };

    public validationIcons = {
        [ValidationStates.PENDING]: faCircleNotch,
        [ValidationStates.ERROR]: faTimesCircle,
        [ValidationStates.SUCCESS]: faSolidCheckCircle,
        [ValidationStates.VALIDATING]: faCircleNotch,
    };
    public input: string = null as any;

    public ValidationStates = ValidationStates;

    get value() {
        return this.$refs.input.value;
    }

    public created() {
        this.input = this.defaultValue;
    }

    public isValidationState(validationState: ValidationStates) {
        return this.validationState === validationState;
    }

    public onBarcodeReaderInput(input) {
        this.input = input;
    }

    public blur() {
        // @ts-ignore
        this.$refs.input.$el.blur();
    }

    public focus() {
        // @ts-ignore
        this.$refs.input.$el.focus();
    }

    public select() {
        // @ts-ignore
        this.$refs.input.$el.select();
    }

    public write(value: string) {
        this.input = value;
    }

    public clear() {
        this.input = null as any;
    }

    private onClick() {
        this.$emit('click')
    }

    @Watch('input', { immediate: false })
    private onInputChange(value) {
        this.$emit('change', value);
    }
}
